import camelCase from 'lodash/camelCase'
import Typography from '@mui/material/Typography'

import Card from 'app/shared-components/Card'
import {
    DTOCardFormField,
} from 'app/types/form.types'

import Form from '../../Form'

import useStyles from './GroupWithCard.style'

const defaultProps = {
    classNames: {},
}

const GroupWithCard = (props: Readonly<{
    fields: DTOCardFormField<any>[],
    classNames: {
        gridCardWrapper: string,
        title: string,
    }
}>) => {
    const {
        fields,
        classNames,
    } = props

    const {
        classes, cx,
    } = useStyles()

    return (
        <>
            {
                fields.map(({
                    title,
                    titleIcon,
                    getTitlePanelElements,
                    className,
                    classNames: classNamesField,
                    fields: groupFields,
                    id,
                    'data-testid': dataTestid = 'group',
                }) => {
                    return (
                        <Card
                            key={`${camelCase(title)}-${id}`}
                            fullHeight
                            className={cx(classes.root, className)}
                            contentClass={classNamesField?.wrapper || className}
                            data-testid={dataTestid}
                        >
                            <Typography
                                variant="h3"
                                className={classNamesField?.title || classNames.title}
                            >
                                <div className={classes.titlePanelContainer}>
                                    <div>
                                        {titleIcon && (
                                            <img
                                                className={classes.titleIcon}
                                                src={titleIcon}
                                                alt={title}
                                            />
                                        )}
                                        {title}
                                    </div>
                                    {
                                        getTitlePanelElements ? (
                                            <div>
                                                {
                                                    (getTitlePanelElements() || []).map((el) => {
                                                        return el
                                                    })
                                                }
                                            </div>
                                        ) : null
                                    }
                                </div>
                            </Typography>

                            <div
                                className={cx(
                                    classes.gridCardWrapper,
                                    classNames.gridCardWrapper,
                                    classNamesField?.gridCardWrapper,
                                    className,
                                )}
                            >
                                {
                                    groupFields[0].fields && groupFields.map((item) => {
                                        return (
                                            <div
                                                key={item.id}
                                                className={item.className}
                                            >
                                                <Form
                                                    {...props} /* eslint-disable-line */
                                                    fields={item.fields}
                                                />
                                            </div>
                                        )
                                    })
                                }
                                {
                                    !groupFields[0].fields && (
                                        <Form
                                            {...props} /* eslint-disable-line */
                                            fields={groupFields}
                                        />
                                    )
                                }
                            </div>
                        </Card>
                    )
                })
            }
        </>
    )
}

GroupWithCard.defaultProps = defaultProps

export default GroupWithCard
